<div class="h-100" [class.no-pointer-events]="closeOutsideDisabled">
  <router-outlet id="main" />

  @if (showCookies) {
    <app-lightbox-cookies (action)="manageActionCookies($event)" />
  }
  <app-alert />
  <app-tour />
</div>
